<template>
  <div class="main">
    <Header 
      :show="true"
      title="骨料车数"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="通过人工进行干预，请谨慎修改"
      />
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          width="60"
        >
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column
          label="名称"
          prop="name"
          align="center"
          min-width="120"
        >
          <template slot-scope="{row}">
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="车数"
          prop="value"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.value }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPermission([272])"
          label="操作"
          prop="operation"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            <el-button
              size="mini"
              type="primary"
              @click="handleClickUpdateDialog(row)"
            >
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <van-dialog
        v-model="dialogVisibleUpdate" 
        title="骨料车数配置"
        show-cancel-button
        :before-close="handleClickUpdateConfirm"
      >
        <van-field
          v-model.trim="listQuery.current"
          label="当前车数"
          placeholder="请输入正确当前值"
          required
          readonly
        />
        <van-field
          v-model.trim="listQuery.set"
          label="设定车数"
          placeholder="请输入正确设定值"
          required
        />
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>

  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList, updateOne } from '@/api/switch.js'
  import { getAllowOne, updateAllowOne, getCurrentOne, updateCurrentOne } from '@/api/number.js'

  export default {
    name: "ServiceProjectNumber",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisibleUpdate: false,
        isLoading: false,
        loading: false,
        table: {
          listLoading: false,
          height: document.documentElement.clientHeight-340,
          key: 0,
          total: 0,
          data: [{id: 1, serial: 1, name: '允许滞留车数', value: 0}, {id: 2, serial: 2, name: '当前滞留车数', value: 0}]
        },
        listQuery: {
          page: 1,
          limit: 10,
          name: 0,
          current: 0,
          set: 0
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {} ,
        })
      },
      handleClickQuery() {
        const data = {}
        getAllowOne(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            for (let i=0; i<items.length; i++) {
              if (items[i].type === '生产设定') {
                if (items[i].name === '骨料车最大在场数量') {
                  this.table.data[0].serial = items[i].id
                  this.table.data[0].value = items[i].value
                }
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
        
        getCurrentOne(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.table.data[1].value = items
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdateDialog(row) {
        console.log(row)
        this.listQuery.serial = row.serial
        this.listQuery.name = row.name
        this.listQuery.current = row.value
        this.listQuery.set = row.value
        console.log(this.listQuery)
        this.dialogVisibleUpdate = true
      },
      handleClickUpdateConfirm(action, done) {
        if (action === 'confirm') {
          if (this.listQuery.name === '允许滞留车数') {
            const data = {
              id: this.listQuery.serial,
              value: this.listQuery.set
            }
            this.loading = true
            updateAllowOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新生产设定', data.message)) {
                this.handleClickQuery()
              }
              done(true)
              this.loading = false
            }).catch(function(error) {
              done(true)
              this.loading = false
              console.error(error)
            })
          } else {
            const data = {
              number: this.listQuery.set
            }
            this.loading = true
            updateCurrentOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新生产设定', data.message)) {
                this.handleClickQuery()
              }
              done(true)
              this.loading = false
            }).catch(function(error) {
              done(true)
              this.loading = false
              console.error(error)
            })
          }
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消设定')
          done(true)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .van-cell__title {
    max-width: 100%;
  }
  ::v-deep .van-field__label {
    width: 30%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
